import React, { useEffect, useState } from 'react';
import { FaInfoCircle  } from 'react-icons/fa';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import { AboutFormProps } from '../../../types/onboardingTypes';
import { BackButton, NextButton } from '../shared/Buttons';
import { Theme } from '../../../lib/theme';

const AboutForm: React.FC<AboutFormProps> = ({
  onContinue,
  onBack,
  initialData,
  isNextLoading,
}) => {
  
  const [about, setAbout] = useState(initialData );
  const [isAboutValid, setIsAboutValid] = useState(true);
  const country = sessionStorage.getItem('country') || 'IN'
  
  useEffect(() => {
    setAbout(initialData );
  }, [initialData]);

  const handleAboutChange = (  e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const value = e.target.value;
    setAbout(value);
    setIsAboutValid(true); 
  };

  const handleSubmit = (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    onContinue({ about });
  };

  const isFormValid =
    (about === '') || 
    ((about === '' || isAboutValid) 
     );

  return (
    <div className="lg:p-0 p-2 w-full mt-[4rem] xl:mt-[2rem] 2xl:mt-[3rem] md:h-[90%] md:w-[80%] md:bg-white md:shadow-lg md:rounded-3xl md:flex md:flex-col md:items-center md:justify-between md:p-4">
      {/* Heading Section */}
      <div className="flex flex-col items-center gap-2 mb-6">
        <FaInfoCircle 
          className="text-5xl xl:text-6xl mb-2"
          style={{ color: Theme.colors.primary }}
        />
        <h1
          className="text-2xl font-bold"
          style={{ color: Theme.colors.text.strong }}
        >
          About the Company
        </h1>
        <p className="text-sm" style={{ color: Theme.colors.text.weak }}>
         Provide Brief description of the startup/idea.
        </p>
      </div>

      {/* Form Section */}
      <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto flex-grow flex flex-col justify-center">
        <div className="flex flex-col gap-4">
          {/* About Input */}
          <div className="flex flex-col gap-2">
            <label
              className="font-semibold"
              style={{ color: Theme.colors.text.strong }}
            >
              About the Company
            </label>
            <textarea
              
              placeholder='Brief description about the startup/idea'
              className="p-3 border w-full rounded-xl min-h-[100px] lg:h-[200px] xl:h-[250px] text-start"
              style={{
                borderColor: !isAboutValid ? Theme.colors.error : Theme.colors.stroke.weak,
                outlineColor: Theme.colors.primary,
              }}
              value={about}
              onChange={handleAboutChange}
            />
           
          </div> 
        </div>
      </form>

      {/* Button Section */}
      <div className="lg:w-[40%] flex flex-col items-center lg:p-2 py-4 px-2 mt-auto lg:pb-20 gap-2">
        {isNextLoading ? (
          <div
            className="w-10 h-10 border-4 border-gray-300 rounded-full animate-spin"
            style={{ borderTopColor: Theme.colors.primary }}
          ></div>
        ) : about.length > 0 ? (
          <>
            <NextButton
              text={'Continue'}
              disabled={!isAboutValid}
              onClick={handleSubmit}
            />
            <BackButton onClick={onBack} />
          </>
        ) : (
          <>
            <NextButton
              text={'Skip'}
              onClick={() => onContinue({ about: '' })}
            />
            <BackButton onClick={onBack} />
          </>
        )}
      </div>
    </div>
  );
};

export default AboutForm;
